// In-game shop navigation helpers.
//
// The activities page picks its tab from the URL hash and falls back to the
// Overview tab when there isn't one, so every exit out of the shop has to
// carry #in-game-shop or the rider gets dropped on the wrong tab.
const ACTIVITIES_PATH = "/user/activities";
const SHOP_HASH = "#in-game-shop";

export const IN_GAME_SHOP_URL = `${ACTIVITIES_PATH}${SHOP_HASH}`;

// Sends the rider back to the shop tab with a fresh page load, so balances and
// owned items reflect the purchase that just completed.
//
// Assigning location.href only reloads when something other than the fragment
// changes. Coming from the shop tab the target differs by nothing at all, so a
// plain assignment does nothing and the button looks broken — hence the split.
export const returnToInGameShop = () => {
  const onActivities =
    window.location.pathname === ACTIVITIES_PATH && !window.location.search;

  if (onActivities) {
    if (window.location.hash !== SHOP_HASH) {
      window.location.hash = SHOP_HASH;
    }
    window.location.reload();
    return;
  }

  // Different path, or a checkout query string worth dropping: a real navigation.
  window.location.href = IN_GAME_SHOP_URL;
};
